import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { globalVar } from './shared/global_variables';

/**
 * Enumeration of all supported languages.
 */
export const enum Languages {
    EN = 'EN',
    DE = 'DE',
    CN = 'CN',
    ES = 'ES',
    PT = 'PT',
    HU = 'HU'
}

/**
 * Loader used for loading translation files via http.
 */

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, environment.baseUrl + globalVar.requestPrefix + globalVar.searchByLanguage, '');
}
